module.exports = __webpack_public_path__ + "assets/img/sidemenu-item03_active.a86b9a55.svg";